/** Query-Parameter, Pfade und Breadcrumbs für Objekt-Hub (Kunde → Objekt → Projekt/Service). */

export const OBJEKT_PROJEKT_CREATE_TYPEN = [
  "elektro",
  "pv",
  "sicherheit",
  "ladestation",
  "ladenbau",
  "intern",
];

export function objektCreateQuery(kundeId, objektId) {
  return new URLSearchParams({
    kunde_id: String(kundeId),
    objekt_id: String(objektId),
  }).toString();
}

export function projektCreatePath(typ, kundeId, objektId) {
  return `/projekte/${typ}/neu?${objektCreateQuery(kundeId, objektId)}`;
}

export function serviceCreatePath(kundeId, objektId) {
  return `/service/neu?${objektCreateQuery(kundeId, objektId)}`;
}

export function offerteCreatePath(kundeId, objektId) {
  return `/offerten/neu?${objektCreateQuery(kundeId, objektId)}`;
}

export function wartungCreatePath(kundeId, objektId) {
  return `/wartungsvertraege/neu?${objektCreateQuery(kundeId, objektId)}`;
}

export function maengelCreatePath(kundeId, objektId) {
  return `/maengel/neu?${objektCreateQuery(kundeId, objektId)}`;
}

export function kundeAddressFromPrefill(fromState = {}) {
  if (fromState.kunden_strasse && fromState.kunden_plz && fromState.kunden_ort) {
    return `${fromState.kunden_strasse}, ${fromState.kunden_plz} ${fromState.kunden_ort}`;
  }
  return "";
}

/** Liest kunde_id / objekt_id aus Query oder Router-State. */
export function parseObjektHubPrefill(location) {
  const sp = new URLSearchParams(location?.search || "");
  const fromState = location?.state?.prefill || {};
  const kundeId = Number(fromState.kunde_id ?? sp.get("kunde_id")) || null;
  const objektId = Number(fromState.objekt_id ?? sp.get("objekt_id")) || null;
  const kundeLabel =
    fromState.kunden_name ||
    [fromState.kunden_firma, [fromState.kunden_vorname, fromState.kunden_nachname].filter(Boolean).join(" ")]
      .filter(Boolean)
      .join(" · ") ||
    null;

  return {
    kundeId,
    objektId,
    fromState,
    kundeLabel,
    objektLabel: fromState.objekt_name || null,
  };
}

/** Breadcrumb-Items für Kunde → Objekt → aktuelle Entität. */
export function buildEntityHubBreadcrumb({
  kundeId,
  kundeLabel,
  objektId,
  objektLabel,
  currentLabel,
}) {
  const items = [];
  if (kundeId) {
    items.push({
      label: kundeLabel || `Kunde #${kundeId}`,
      to: `/kunden/${kundeId}`,
    });
  }
  if (objektId) {
    items.push({
      label: objektLabel || `Objekt #${objektId}`,
      to: `/objekte/${objektId}`,
    });
  }
  if (currentLabel) items.push({ label: currentLabel });
  return items;
}

/** Rücknavigation: bevorzugt Objekt, dann Kunde, sonst Fallback. */
export function objektHubBackPath({ kundeId, objektId, fallback = "/" }) {
  if (objektId) return `/objekte/${objektId}`;
  if (kundeId) return `/kunden/${kundeId}`;
  return fallback;
}

export function projektHubFormPatch(prefill, existing = {}) {
  const { kundeId, objektId, fromState } = prefill;
  if (!kundeId && !objektId) return null;
  const addr = kundeAddressFromPrefill(fromState);
  return {
    ...(kundeId
      ? {
          kunde_id: kundeId,
          kunden_id: kundeId,
          einsatzort_text: existing.einsatzort_text || addr || "",
          verwaltung_text: existing.verwaltung_text || fromState.kunden_name || "",
        }
      : {}),
    ...(objektId ? { objekt_id: objektId, einsatzort_mode: "objekt" } : {}),
  };
}

export function serviceHubFormPatch(prefill, existing = {}) {
  const { kundeId, objektId, fromState } = prefill;
  if (!kundeId && !objektId) return null;
  const addr = kundeAddressFromPrefill(fromState);
  return {
    ...(kundeId
      ? {
          kunde_id: kundeId,
          kunden_id: kundeId,
          abweichende_adresse: existing.abweichende_adresse || addr || "",
          verwaltung_text: existing.verwaltung_text || fromState.kunden_name || "",
        }
      : {}),
    ...(objektId ? { objekt_id: objektId } : {}),
  };
}
